// clean up deprecated repository UI settings keys
export default (settings: Record<string, any>) => {
  const deprecatedSettings = [
    'ANALYTICS_DASHBOARD_INCOME_SOURCE',
    'ANALYTICS_DASHBOARD_VALUE_GROUP_FIELD',
    'ANALYTICS_DASHBOARD_VALUE_SOURCE',
    'ANALYTICS_PORTFOLIO_INCOME_SOURCE',
    'ANALYTICS_PORTFOLIO_VALUE_SOURCE',
    'ANALYTICS_GROUP',
    'ANALYTICS_INCOME_METRIC',
    'ANALYTICS_VALUE_METRIC',
    'ANALYTICS_VALUE_METRIC_CATEGORY',
    'ANALYTICS_PERFORMANCE_GROUP_BY',
    'LINKED_TRANSACTIONS',
    'LINKED_TRANSACTION_PIVOT_1',
    'PIVOT_PERFORMANCE',
    'PIVOT_PERFORMANCE_V2',
    'PIVOT_VALUE',
    'LINKED_TRANSACTIONS_PIVOT_COLS',
    'LINKED_TRANSACTIONS_PIVOT_FILTER',
    'LINKED_TRANSACTIONS_PIVOT_PANEL_OPENED',
    'LINKED_TRANSACTIONS_PIVOT_ROWS',
    'LINKED_TRANSACTIONS_PIVOT_SORT_COLUMNS',
    'LINKED_TRANSACTIONS_PIVOT_SORT_ROWS',
    'LINKED_TRANSACTIONS_PIVOT_TYPE',
    'LINKED_TRANSACTIONS_PIVOT_VALUES',
    'PERFORMANCE_PIVOT_FILTER',
    'PERFORMANCE_PIVOT_PANEL_OPENED',
    'PERFORMANCE_PIVOT_ROWS',
    'PERFORMANCE_PIVOT_SORT_COLUMNS',
    'PERFORMANCE_PIVOT_SORT_ROWS',
    'PERFORMANCE_PIVOT_TYPE',
    'PERFORMANCE_PIVOT_VALUES',
    'VALUE_PIVOT_COLS',
    'VALUE_PIVOT_FILTER',
    'VALUE_PIVOT_PANEL_OPENED',
    'VALUE_PIVOT_ROWS',
    'VALUE_PIVOT_SORT_COLUMNS',
    'VALUE_PIVOT_SORT_ROWS',
    'VALUE_PIVOT_TYPE',
    'VALUE_PIVOT_VALUES',
    'pivot',
    'linked',
    'linked_data',
    'widgets',
    'dashboard',
  ]
  deprecatedSettings.forEach(setting => {
    if (settings[setting] !== undefined) {
      settings[setting] = undefined
    }
  })
}
